export default __webpack_public_path__ + "static/media/error_outline_black_24dp.f5456b19.png";